export default __webpack_public_path__ + "static/CliveVaz-2278047590b6aa515454208fc150e4dd.png";